export function hasCanonicalPermission(authUser, permission) {
  return authUser?.permissions?.includes(permission) === true;
}
